import * as state from './state.js';
import { createYamlEditor, ProgrammaticChange } from './editor-view.js';
import { createCodePreview } from './code-preview.js';

const SQL_BLOCKS_ENDPOINT = '/api/highlighting/sql-blocks';
const COMPLETION_CATALOG_ENDPOINT = '/api/completion-catalog';

async function fetchSqlBlocks() {
    const response = await fetch(SQL_BLOCKS_ENDPOINT);
    if (!response.ok) {
        throw new Error(`Failed to load SQL block scalar rules: ${response.status}`);
    }
    return response.json();
}

async function fetchCompletionCatalog() {
    const response = await fetch(COMPLETION_CATALOG_ENDPOINT);
    if (!response.ok) {
        throw new Error(`Failed to load dbt charts completion catalog: ${response.status}`);
    }
    return response.json();
}

export async function initEditor(sendYAMLToPreviewFn) {
    // Catalog-fetch failure degrades to an empty schema (completion source
    // returns no options, so the editor loads fully usable without
    // completion) rather than blocking the editor on a non-essential fetch.
    // The SQL block rules fetch is not guarded — it's a required parameter
    // for the shared language, so a failure here is a real error.
    const [sqlBlocks, catalog] = await Promise.all([
        fetchSqlBlocks(),
        fetchCompletionCatalog().catch((error) => {
            console.warn('dbt charts YAML completions unavailable', error);
            return {};
        }),
    ]);

    state.setSqlBlocks(sqlBlocks);

    let previewTimeout = null;
    const editorInstance = createYamlEditor({
        parent: document.getElementById('yaml-editor'),
        sqlBlocks,
        catalog,
        onDocChange(update) {
            if (!update.docChanged) return;
            // Programmatic setDoc() (gallery/AI sidebar/URL-yaml bootstrap) fires
            // its own explicit render — the debounced one here would duplicate it.
            if (update.transactions.some((tr) => tr.annotation(ProgrammaticChange))) return;

            clearTimeout(previewTimeout);
            previewTimeout = setTimeout(() => {
                sendYAMLToPreviewFn();
            }, 500);
        },
    });

    const codePreviewInstance = createCodePreview(document.getElementById('code-preview'));

    state.setEditor(editorInstance);
    state.setCodePreview(codePreviewInstance);

    return { editor: editorInstance, codePreview: codePreviewInstance };
}
